// 是否有任务
export const REPORT_TYPE_DATA = [
  { label: '1小时报', value: 1 },
  { label: '2小时报', value: 2 },
  { label: '日报', value: 10 },
];
